import './MainPageSub07_1.scss';

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import HongButton from '../comm/HongButton';

const MainPageSub07_1 = () => {

    const navigate = useNavigate();

    function handleLoginWhere() {
        navigate('/loginWhere');
    }

    //=====================================================================
    return (
        <div className="MainPageSub07_1">
            <section className='sec-main'>

                <p className="heading-1 title1">
                    07 <span className="i-custom">진단분석 Sample</span>
                </p>

                <section className='sec-sub1'>
                    <article className='art-main'>
                       
            
                    </article>

                    <article className='art-menu'>
                       
                       <HongButton className='h-btn-black btn1' onClick={handleLoginWhere}>진단하기<br /><span>START</span></HongButton>
            
                    </article>

                </section>

            </section>
        </div>
    );
};

export default MainPageSub07_1;
